import { TerritoryPenaltyStatusEnum } from '@/config/types';
import { apiConfig } from '../api-config';

export default async function (id: string, penaltyStatus: TerritoryPenaltyStatusEnum) {
  return apiConfig
    .patch(`api/territory/penalty-status/${id}`, penaltyStatus as number, { headers: { 'Content-Type': 'application/json' } })
    .catch((error) => console.log(error));
}
